export default "__VITE_ASSET__D6z0c$7U__"